import React from 'react';
import styles from '../Operations.module.css';

interface BTACComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const BTAC: BTACComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        This metric displays the count of new and existing business segmented customers whose sales make up your current year rolling 12-month B2B sales.
        <br />
        • &quot;Current year&quot; is defined as the most recent consecutive 12 months, and &quot;prior year&quot; is defined as the 12 months immediately preceding &quot;current year&quot;.
        <br />
        • New customers: customers that have purchases in the most recent rolling 12 months for the calculation year. Once a customer has purchases going back longer than 12 months, they are considered existing customers.
        <br />
        • Segmented business customers without any transactions in the past 12 months are not counted.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        To be counted, a customer must be business segmented and have at least one transaction in the past 12 months.
        <br /><br />
        The active customer count metric is not a Higher Ground achievement on its own but is a component of the overall YOY Growth metric and the Sales % to Total metric.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        The goal for Active Customer Count is a combined total of the Active Existing Customer Count and Active New Customer Count goals.
        <br /><br />
        The goal for Active New Customer Count is 25 per year (static).
        <br /><br />
        The goal for Active Existing Customer Count is to maintain the number of active existing customers that were active over the last 12 months as of the month prior (dynamic).
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>
      <div className={styles.sectionContent}>
        The drill down will show you a list of your active business segmented customers over the &quot;current year&quot; and &quot;prior year&quot;.
        <br /><br />
        Business segmented customers that were active during the &quot;current year&quot; count towards the Active Customer Count metric; business segmented customers that were only active during the &quot;prior year&quot; do NOT count towards the Active Customer Count metric.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        Review the customer segmentation in your POS system to be sure all business customers are being counted.
        <br /><br />
        Your Field Sales Manager can assist by providing a report (Alteryx Segmentation Report) that shows all customers in your system and the segment that is tied to them. 
        <br /><br />
        This report is for Epicor Eagle for Windows and Propello systems only.  
        <br /><br />
        For more information on segmentation, go to{' '}
        <a
          href="https://acenet.aceservices.com/awor/b2b-operations-and-processes/b2b-customer-segmentation"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          AWOR &gt; Business to Business - B2B Operations and Processes &gt; B2B Customer Segmentation
        </a>.
      </div>
    </div>
  );
};

// Attach title as a static property
BTAC.title = 'Business to Business Metrics (Active Customer Count)';
BTAC.actionTitle = 'Evaluate Customers (New + Existing)';
BTAC.actionHyperlink = 'dynamicURL:WFC:current';

export default BTAC;

